import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule } from "owa-bundling";

export const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "MailListItemSharedLazy"*/ "./lazyIndex"), { name: "MailListItemSharedLazy" });

export const lazyUpdateRsvpInCalendarCard: LazyAction<typeof lazyIndex.updateRsvpInCalendarCard, typeof lazyModule> = new LazyAction(lazyModule, m => m.updateRsvpInCalendarCard);

export const lazyUpdateRsvpInSubjectHeader: LazyAction<typeof lazyIndex.updateRsvpInSubjectHeader, typeof lazyModule> = new LazyAction(lazyModule, m => m.updateRsvpInSubjectHeader);
